import React from "react";
import { LineWave } from "react-loader-spinner";
import { FaUsers, FaPercentage } from "react-icons/fa";
import { GrMoney } from "react-icons/gr";
import { TbUsersPlus, TbUsersMinus } from "react-icons/tb";
import { IoMdTime } from "react-icons/io";

const CardWrapper = ({ children }) => {
  return (
    <div className="w-full md:w-1/2 lg:w-1/2 xl:w-1/2 px-2 mb-7">
      {children}
    </div>
  );
};

const CardContent = ({ icon: Icon, title, label, value }) => {
  return (
    <div className="bg-[#211849] text-white p-8 rounded">
      <div className="flex justify-between items-center">
        <div className="w-[60px] h-[60px] flex justify-center items-center rounded-full bg-white-500 bg-custom-color bg-opacity-100 min-w-[60px]">
          <Icon className="text-white text-[30px]" />
        </div>
        <p className="text-[20px]">{title}</p>
      </div>
        <p className="text-[18px] text-right">{label}</p>
      <p className="text-right text-[45px] font-bold">{value}</p>
    </div>
  );
};

export default function Statistics({ dashboard, isLoading }) {
  return (
    <div className="flex flex-wrap -mx-2 pr-2 pl-2">
      <CardWrapper>
        <CardContent
          icon={FaUsers}
          title="Total Active Subscribers"
          label="Everyday Tier"
          value={dashboard?.data?.activeFreeUser}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={FaUsers}
          title="Total Active Subscribers"
          label="Hero Tier"
          value={dashboard?.data?.activePaidUser}
        />
      </CardWrapper>
      {/* <CardWrapper>
        <CardContent
          icon={FaUsers}
          title="Total Inactive Paid User"
          value={dashboard?.data?.inactivePaidUser}
        />
      </CardWrapper> */}
      <CardWrapper>
        <CardContent
          icon={TbUsersPlus}
          title="New Subscribers"
          label="Everyday Tier"
          value={dashboard?.data?.newActiveFreeUser}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={TbUsersPlus}
          title="New Subscribers"
          label="Hero Tier"
          value={dashboard?.data?.newPaidUser}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={TbUsersMinus}
          title="Churned Subscribers"
          label="Everyday Tier"
          value={dashboard?.data?.churnedFreeSubscriber}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={TbUsersMinus}
          title="Churned Subscribers"
          label="Hero Tier"
          value={dashboard?.data?.churnedPaidSubscriber}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={IoMdTime}
          title="Average Session Time"
          label="Per Everyday Subscriber"
          value={dashboard?.data?.averagSessionTimeFreeSubscriber}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={IoMdTime}
          title="Average Session Time"
          label="Per Hero Subscriber"
          value={dashboard?.data?.averagSessionTimePaidSubscriber}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={GrMoney}
          title="Monthly Recurring Revenue"
          value={dashboard?.data?.monthlyRecurringRevenue}
        />
      </CardWrapper>
      <CardWrapper>
        <CardContent
          icon={FaPercentage}
          title="Annually Paying Subscribers"
          value={dashboard?.data?.yearlySubscriberPercentage}
        />
      </CardWrapper>
      
      {isLoading && (
        <div className="loader">
          <LineWave color={"#fff"} loading={isLoading} size={150} />
        </div>
      )}
    </div>
  );
}
